import Benutzerliste from "@/pages/Dashboardlisten/Benutzerliste";
import Benutzer from "@/pages/Admin/Benutzer";
import SsoTenantListe from "@/pages/Admin/SsoTenantListe";
import SsoTenant from "@/pages/Admin/SsoTenant";

export default [
  {
    path: "/admin/benutzerliste",
    name: "benutzer-liste",
    component: Benutzerliste,
  },
  {
    path: "/admin/benutzer/:id?/:anzeige",
    name: "benutzer",
    component: Benutzer,
    props: (route) => {
      const a = parseInt(route.params.anzeige, 10);
      return {
        id: route.params.id,
        anzeige: isNaN(a) ? 0 : a,
      };
    },
  },
  {
    path: "/admin/sso-tenants",
    name: "sso-tenant-liste",
    component: SsoTenantListe,
  },
  {
    path: "/admin/sso-tenant/:id?",
    name: "sso-tenant",
    component: SsoTenant,
    props: (route) => ({ id: route.params.id || null }),
  },
];